export default {
    'pitkatilaus-maaraaikainen': { fi: 'Varaava', sv: '', en: 'Fixed-period', ru: '', sk: '', pl: '' },
}
